import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MaintenanceService } from '../services/maintenance.service';
import { tap } from 'rxjs/operators';
import { STATUS_CODES } from '../constants';
import { MaintenanceInfoDto } from '../dtos/maintenance-info.dto';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private maintenanceService = inject(MaintenanceService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: res => {
          if (
            res instanceof HttpErrorResponse
            && res.status === STATUS_CODES.maintenance
            && (res.error as MaintenanceInfoDto)?.isMaintenanceInProgress
          ) {
            this.maintenanceService.setMaintenanceInfo(res.error);
          }
        },
      })
    );
  }

}
